import { FormControl, FormHelperText, InputLabel, MenuItem, Select } from '@mui/material'
import { LocalNext } from '../../domain/form/definition/LocalNext'
import NextOption from '../input/NextOption'

export type NextElementType = 'page' | 'item'

export type NextElementDisplayProps = {
  value?: LocalNext
  options?: readonly NextOption[]
  type: NextElementType
}

const NextElementDisplay: React.FC<NextElementDisplayProps> = ({ value, options = [], type }) => {
  const defaultText = type === 'page' ? 'Next page' : 'Next item'
  const labelId = 'next-element-display-label'

  const currentOption = value ? options?.find((o) => o.next.key === value.key)?.label : undefined
  const hasError = value && !currentOption

  return (
    <FormControl disabled error={hasError}>
      <InputLabel id={labelId} shrink>
        {'Go to'}
      </InputLabel>
      <Select
        labelId={labelId}
        label={'Go to'}
        value={value ?? ''}
        renderValue={(value) => {
          const option = options.find(({ next }) => next.key === value.key)?.label

          return option ?? value.key ?? defaultText
        }}
        displayEmpty
        sx={{ minWidth: 200 }}
      >
        <MenuItem value={''}>{defaultText}</MenuItem>
      </Select>
      {hasError && <FormHelperText error>{`Invalid ${value?.type ?? ''} selected`}</FormHelperText>}
    </FormControl>
  )
}

export default NextElementDisplay
